var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4142 5C4.4142 5.40611 4.57553 5.79559 4.8627 6.08276C5.14986 6.36992 5.53934 6.53125 5.94545 6.53125C6.35157 6.53125 6.74105 6.36992 7.02821 6.08276C7.31538 5.79559 7.4767 5.40611 7.4767 5C7.4767 4.59389 7.31538 4.20441 7.02821 3.91724C6.74105 3.63008 6.35157 3.46875 5.94545 3.46875C5.53934 3.46875 5.14986 3.63008 4.8627 3.91724C4.57553 4.20441 4.4142 4.59389 4.4142 5V5ZM11.8818 4.64727C10.5857 1.91699 8.62651 0.542969 6.00014 0.542969C3.37241 0.542969 1.41459 1.91699 0.118499 4.64863C0.0665126 4.75871 0.0395508 4.87894 0.0395508 5.00068C0.0395508 5.12242 0.0665126 5.24265 0.118499 5.35273C1.41459 8.08301 3.37377 9.45703 6.00014 9.45703C8.62787 9.45703 10.5857 8.08301 11.8818 5.35137C11.9871 5.12988 11.9871 4.87285 11.8818 4.64727V4.64727ZM5.94545 7.40625C4.61655 7.40625 3.5392 6.32891 3.5392 5C3.5392 3.67109 4.61655 2.59375 5.94545 2.59375C7.27436 2.59375 8.3517 3.67109 8.3517 5C8.3517 6.32891 7.27436 7.40625 5.94545 7.40625Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.f78853e2a24e50a6048bbcf571dbb1db.svg";
export { ForwardRef as ReactComponent };